module.exports = __webpack_public_path__ + "img/tianle.c8bafeb4.jpeg";